/** @typedef {import("../types").StateRelatoOcorrencia} StateRelatoOcorrencia */

/**
 * Getters do módulo relatoOcorrencia.
 * Exposições simples do estado + `hasFiltrosAtivos`.
 */
export default {
  filtros: state => state.filtros,
  paginaAtual: state => state.paginaAtual,
  itensPorPagina: state => state.itensPorPagina,
  totalRegistros: state => state.totalRegistros,
  loading: state => state.loading,
  /**
   * Indica se existe ao menos um filtro preenchido (diferente de null/"").
   * @param {StateRelatoOcorrencia} state
   * @returns {boolean}
   */
  hasFiltrosAtivos: state =>
    Object.values(state.filtros).some(
      v => v !== null && v !== undefined && v !== ""
    )
};
